import { Observable } from 'rxjs';
import { Language } from '@app/core/models';

export interface AppStateInterface {
  getLanguage(): Observable<Language>;
  setLanguage(lang: Language): void;
  isAuthenticated(): Observable<boolean>;
  setAuthenticated(status: boolean): void;
  getError(): Observable<boolean>;
  setError(): void;
  resetError(): void;
}

export class AppStateBase implements AppStateInterface {
  getLanguage(): any { }
  setLanguage(lang: Language): void { }
  isAuthenticated(): any { }
  setAuthenticated(status: boolean): void { }
  getError(): any { }
  setError(): void { }
  resetError(): void {}
}
